var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"linkedTabsItem"},[_c('nuxt-link',{class:{ 'nuxt-link-active': _vm.isActive},attrs:{"to":_vm.to,"append":_vm.append,"disabled":_vm.disabled,"tabindex":_vm.disabled ? -1 : 0,"exact":_vm.exact}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }